export enum LocalStorageKeys {
  language = "language",
}
